module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/common/icon_pin-61b4b3636fa56cf09e5ebb683fb36d46.svg";